import { render, staticRenderFns } from "./AwardSetting.vue?vue&type=template&id=5944f81a&scoped=true&"
import script from "./AwardSetting.vue?vue&type=script&lang=js&"
export * from "./AwardSetting.vue?vue&type=script&lang=js&"
import style0 from "./AwardSetting.vue?vue&type=style&index=0&id=5944f81a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5944f81a",
  null
  
)

export default component.exports